import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Card, Icon, IconButton, Popover } from '@material-ui/core';
import { CardContent, CardTitle, ConfigFieldControl } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
import ComponentPicker from './ComponentPicker';
const StyledCard = styled(Card) `
  .title {
    padding-top: 10px;
  }
`;
const NestedComponentPicker = props => {
    const { children, className, componentType, configureComponent, onTypeChange } = props;
    const { plugins } = useSiteContext();
    const [anchorElement, setAnchorElement] = useState();
    const plugin = useMemo(() => plugins.find(p => p.type === (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.type)), [configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.type, plugins]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: 'small', className: className, onClick: event => setAnchorElement(event.currentTarget) },
            React.createElement(Icon, null, "input")),
        React.createElement(Popover, { keepMounted: true, open: !!anchorElement, anchorEl: anchorElement, onClose: () => setAnchorElement(undefined), PaperProps: { style: { width: 240, maxHeight: 360 } }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' } },
            React.createElement(StyledCard, { elevation: 0 },
                React.createElement(CardTitle, { className: 'title' }, "Select Query and Field"),
                React.createElement(CardContent, null,
                    React.createElement(ConfigFieldControl, null,
                        React.createElement(ComponentPicker, { label: 'Component', value: componentType, onTypeChange: onTypeChange, helperText: 'Format with component' })),
                    (plugin === null || plugin === void 0 ? void 0 : plugin.configurator) && configureComponent && (React.createElement(plugin.configurator, { component: configureComponent })),
                    children)))));
};
export default NestedComponentPicker;
//# sourceMappingURL=NestedComponentPicker.js.map